export const PATHNAMES = {
  socialProviders: '/ims/social/v2/providers',
  socialCompleteAccount: '/signin/v2/accounts/social/create',
  socialNativeHeadless: '/ims/social/v3/native',
  validateOrigin: '/ims/clients/validate/v1',
  check: '/ims/check/v6/token',
  IJT: '/ims/jump/implicit',
  queryState: '/signin/v1/queryState',
} as const;
